<template>
    <div class="user-verification-wrapper" v-loading="loading">

        <div class="breadcrumb">用户验证信息</div>

        <div class="selectSchool">
            <el-select class="selectInput" v-model="region" filterable clearable placeholder="请输入高校名称"
                @change="changeSchool">
                <el-option v-for="item in schoolOptions" :key="item.value" :label="item.name" :value="item.rootUnid">
                </el-option>
            </el-select>

            <el-button class="right_f" type="primary" v-show="importuserinfo"
                @click="clickFaceRecord">人脸导入记录</el-button>
            <el-button class="right_f" type="primary" v-show="importuserinfo" @click="clickFaceImport">导入人脸</el-button>
            <el-button class="right_f" type="primary" @click="exportModel">导出模板</el-button>
            <el-upload class="right_f" v-show="importuserinfo" :with-credentials='true' :action="importverification"
                :on-success="handleSuccess" :on-error="handleError" name="uploadFile">
                <el-button type="primary">导入用户信息文件</el-button>
            </el-upload>
        </div>

        <div class="tips-content">
            <p>提示：</p>
            <p>1.仅添加用户验证信息，用于身份验证，不会创建用户账号。2.若学号/工号相同，新增记录将覆盖原有记录</p>
            <p>2.只有弹出导入成功文案提示才是导入成功，100%状态的时候是在等待中，如果太久没有导入成功，请刷新页面重新导入</p>
            <p>3.每次模板导入数据请不要超过3000条。</p>
        </div>

        <div class="form-bezel" v-show="isshowuserData">
            <el-form :inline="true">
                <el-form-item label="注册状态:">
                    <el-select v-model="registerStatus">
                        <el-option label="全部" :value="0"></el-option>
                        <el-option label="已注册" :value="1"></el-option>
                        <el-option label="未注册" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="建模状态:">
                    <el-select v-model="faceStatus">
                        <el-option label="全部" :value="0"></el-option>
                        <el-option label="无" :value="1"></el-option>
                        <el-option label="成功" :value="2"></el-option>
                        <el-option label="失败" :value="3"></el-option>

                    </el-select>
                </el-form-item>
                <el-form-item label=" ">
                    <el-input class="name-input" placeholder="请输入学生姓名或学号" v-model="searchName"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button class="searchBtn" type="primary" @click="queryUserList">搜索</el-button>
                </el-form-item>
            </el-form>
            <el-button class="button-export" type="primary" @click="clickExportTable">导出</el-button>
        </div>

        <div class="com-list">
            <el-table v-show="userData.length > 0" :data="userData">
                <el-table-column align="center" label="序号" type="index" width="80"></el-table-column>
                <el-table-column align="center" label="学号/教职工号" prop="stuId" width="250"></el-table-column>
                <el-table-column align="center" label="姓名" prop="name"></el-table-column>
                <el-table-column align="center" label="院系" prop="className"></el-table-column>
                <el-table-column align="center" label="性别" prop="gender"></el-table-column>
                <el-table-column align="center" label="班级" prop="gradeClass"></el-table-column>
                <el-table-column align="center" label="年级" prop="grade"></el-table-column>
                <el-table-column align="center" label="注册状态">
                    <template scope="{row}">
                        {{ row.uid ? '已注册' : '未注册' }}
                    </template>
                </el-table-column>
                <el-table-column align="center" label="人脸图" prop="">
                    <template scope="{row}">
                        <img v-show="row.status === 1" class="face-image" :src="row.faceUrl" alt="">
                        <el-popover v-show="row.status === 2" placement="top" :visible-arrow="false" trigger="hover">
                            <div slot="reference">失败</div>
                            <div>{{ row.incorrectReason }}</div>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="建模状态">
                    <template scope="{row}">
                        <ModelPopover :data-source="row.modelStatusList" />
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="200">
                    <template scope="{row}">
                        <el-button type="text" @click="clickDeleteFace(row)">删除人脸</el-button>
                        <el-button type="text" @click="clickEdit(row)">编辑</el-button>
                        <el-button type="text" @click="clickDelete(row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-pagination v-show="total > 0" layout="prev, pager, next" :page-size='20' :page-count="pageCount"
            :total="total" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>

        <el-dialog title="用户验证信息编辑" size="tiny" :modal-append-to-body="false" v-model="editDialog.visible">
            <el-form class="edit-form" label-width="120px" label-position="left">
                <el-form-item label="学号/教职工号：">
                    <el-input placeholder="请输入学号/教职工号" v-model="editForm.stuId" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item>
                    <label slot="label">
                        姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：
                    </label>
                    <el-input placeholder="请输入姓名" v-model="editForm.name"></el-input>
                </el-form-item>
                <el-form-item>
                    <label slot="label">
                        性&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别：
                    </label>
                    <el-select placeholder="请选择性别" v-model="editForm.gender">
                        <el-option label="男" value="男"></el-option>
                        <el-option label="女" value="女"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <label slot="label">
                        院&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;系：
                    </label>
                    <el-select placeholder="请选择院系" v-model="editForm.className" @change="changeDepartment">
                        <el-option v-for="(item, index) in editDialog.departmentOptions" :key="index"
                            :label="item.department" :value="item.department"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-show="editDialog.classOptions.length > 0">
                    <label slot="label">
                        班&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;级：
                    </label>
                    <el-select placeholder="请选择班级" v-model="editForm.gradeClass">
                        <el-option v-for="(item, index) in editDialog.classOptions" :key="index" :label="item.name"
                            :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <label slot="label">
                        年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;级：
                    </label>
                    <el-select placeholder="请选择年级" v-model="editForm.grade">
                        <el-option v-for="(item, index) in editDialog.editYearOptions" :key="index" :label="item.value"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="editDialog.visible = false">取 消</el-button>
                <el-button type="primary" @click="clickEditDone">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import ModelPopover from './Components/ModelPopover.vue';

export default {
    components: {
        ModelPopover
    },

    data() {
        return {
            loading: false,
            schoolOptions: [],
            region: '',
            registerStatus: 0, // 注册状态 0全部，1已注册，2未注册
            faceStatus: 0, // 建模状态，0全部，1无，2，成功，3失败
            searchName: '',
            userData: [],
            total: 0,
            pageCount: 1,
            importuserinfo: false,
            importurl: '/adminapi/v1/user/checkInfo/importCheckInfo?rootUnid=',
            isshowuserData: false,
            currentPage: 1,
            pageSize: 20,
            editDialog: {
                visible: false,
                departmentOptions: [],
                classOptions: [],
                editYearOptions: [],
            },
            editForm: {
                stuId: '',
                name: '',
                gender: '',
                className: '',
                gradeClass: '',
                grade: '',
            }
        }
    },

    computed: {
        importverification() {
            return this.$util.domain + this.importurl + this.region;
        }
    },

    mounted() {
        this.queryAllSchool();
    },

    methods: {
        // 获取高校列表
        queryAllSchool() {
            this.loading = true;
            this.$http({
                method: 'get',
                url: this.$util.domain + '/adminapi/v1/basicTools/allSchools'
            }).then(response => {
                if (response.data.error == 10000) {
                    this.schoolOptions = response.data.data;
                } else {
                    this.$errorMsg(response.data.message);
                }
            }).finally(() => {
                this.loading = false;
            })
        },

        // 查询学生列表
        queryUserList() {
            this.loading = true;
            let params = {
                rootUnid: this.region,
                registerStatus: this.registerStatus,
                faceStatus: this.faceStatus,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }
            if (this.trim(this.searchName) !== '') {
                params['keyword'] = this.trim(this.searchName);
            }
            this.$http({
                url: this.$util.domain + '/adminapi/v590/user/checkInfo/queryCheckInfo',
                method: 'POST',
                body: JSON.stringify(params),
            }).then(response => {
                if (response.data.error == 10000) {
                    this.userData = response.data.data.models.map((item) => {
                        let modelStatusList = null;
                        if (item.modelStatus) {
                            modelStatusList = JSON.parse(item.modelStatus);
                        }
                        return Object.assign({}, item, { modelStatusList: modelStatusList });
                    }) || [];
                    this.total = response.data.data.totalNum || 0;
                } else {
                    this.$util.errorMsg(response.data.message);
                }
            }).catch((err) => {
                this.userData = [];
                this.total = 0;
            }).finally(() => {
                this.loading = false;
            })
        },

        // 查询学校院系
        querySchoolDepartment() {
            this.loading = true;
            this.$http({
                method: 'post',
                url: this.$util.domain + '/adminapi/v1/campus/department/allDepartment?unid=' + this.region,
            }).then((response) => {
                if (response.data.error == 10000) {
                    this.editDialog.departmentOptions = response.data.data || [];
                    const department = this.editDialog.departmentOptions.find((item) => item.department === this.editForm.className);
                    if (department) {
                        this.queryClassList(department);
                    } else {
                        this.editDialog.classOptions = [];
                    }
                } else {
                    this.editDialog.departmentOptions = [];
                    this.editDialog.classOptions = [];
                }
            }).catch(() => {
                this.editDialog.departmentOptions = [];
                this.editDialog.classOptions = [];
            }).finally(() => {
                this.loading = false;
            });
        },

        // 获取院系下的班级列表
        queryClassList(department) {
            this.loading = true;
            this.$http({
                url: this.$util.domain + "/adminapi/v1/campus/department/classlist",
                method: "POST",
                body: JSON.stringify({
                    departId: department.id,
                    department: department.department,
                    rootUnid: this.region,
                }),
            }).then((response) => {
                if (response.data.error == 10000) {
                    if (response.data.data && response.data.data.length) {
                        this.editDialog.classOptions = response.data.data;
                    } else {
                        this.editDialog.classOptions = [];
                    }
                }
            }).catch(() => {
                this.editDialog.classOptions = [];
            }).finally(() => {
                this.loading = false;
            });
        },

        // 发送更新验证信息
        sendUpdateVerifyInfo(params) {
            this.loading = true;
            this.$http({
                url: this.$util.domain + "/adminapi/v1/user/checkInfo/update",
                method: "POST",
                body: JSON.stringify(params),
            }).then((response) => {
                if (response.data.error == 10000) {
                    this.$util.successMsg('更新成功');
                    this.queryUserList();
                    this.editDialog.visible = false;
                } else {
                    this.$util.errorMsg('更新失败');
                }
            }).catch(() => {
                this.$util.errorMsg('更新失败');
            }).finally(() => {
                this.loading = false;
            });
        },

        // 发送删除人脸信息
        sendDeleteFaceInfo(stuId) {
            this.loading = true;
            this.$http({
                url: this.$util.domain + "/adminapi/v570/user/checkInfo/delUserFace",
                method: "POST",
                body: JSON.stringify({
                    stuId: stuId,
                    rootUnid: this.region,
                }),
            }).then((response) => {
                if (response.data.error == 10000) {
                    this.$util.successMsg('删除成功');
                    this.queryUserList();
                } else {
                    this.$util.errorMsg('删除失败');
                }
            }).catch(() => {
                this.$util.errorMsg('删除失败');
            }).finally(() => {
                this.loading = false;
            });
        },

        // 发送删除验证信息
        sendDeleteVerifyInfo(stuId) {
            this.loading = true;
            this.$http({
                url: this.$util.domain + "/adminapi/v1/user/checkInfo/delete",
                method: "GET",
                params: {
                    campusId: stuId,
                    rootUnid: this.region,
                },
            }).then((response) => {
                if (response.data.error == 10000) {
                    this.$util.successMsg('删除成功');
                    this.queryUserList();
                } else {
                    this.$util.errorMsg('删除失败');
                }
            }).catch(() => {
                this.$util.errorMsg('删除失败');
            }).finally(() => {
                this.loading = false;
            });
        },

        // 切换学校
        changeSchool() {
            if (this.region != 0) {
                this.importuserinfo = true;
                this.isshowuserData = true;
                this.queryUserList();
            } else {
                this.importuserinfo = false;
                this.isshowuserData = false;
                this.userData = [];
                this.total = 0;
                this.$util.errorMsg('请选择一个有效学校');
            }
        },

        // 分页切换
        handleCurrentChange(val) {
            this.currentPage = val;
            this.queryUserList();
        },

        // 上传成功
        handleSuccess(response) {
            if (response.error === 10000) {
                this.$util.successMsg(response.message);
            } else {
                this.$util.errorMsg(response.message);
            }
        },

        // 上传失败
        handleError(response) {
            this.$util.errorMsg(response.message);
        },

        // 导出模板
        exportModel() {
            location.href = "https://admin.gxapp.iydsj.com/template/userinfo_import.xlsx";
        },

        // 点击人脸导入记录
        clickFaceRecord() {
            this.$util.refreshTo("/#/user/facial/record", { rootUnid: this.region });
        },

        // 点击导入人脸
        clickFaceImport() {
            this.$util.refreshTo("/#/user/facial/photo", { rootUnid: this.region });
        },

        // 点击导出表格
        clickExportTable() {
            let url = this.$util.domain + '/adminapi/v590/user/checkInfo/exportCheckInfo'
                + '?rootUnid=' + this.region
                + '&registerStatus=' + this.registerStatus
                + '&faceStatus=' + this.faceStatus;
            if (this.trim(this.searchName) !== '') {
                url += '&keyword=' + this.trim(this.searchName);
            }
            location.href = url;
        },

        // 点击删除人脸
        clickDeleteFace(row) {
            this.$confirm('是否确定删除人脸信息？', '温馨提示', {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: 'warning'
            }).then(() => {
                this.sendDeleteFaceInfo(row.stuId);
            }).catch(() => { });
        },

        // 点击编辑
        clickEdit(row) {
            this.editForm.stuId = row.stuId;
            this.editForm.name = row.name;
            this.editForm.gender = row.gender;
            this.editForm.className = row.className;
            this.editForm.gradeClass = row.gradeClass;
            this.editForm.grade = row.grade;

            if (this.editDialog.editYearOptions.length == 0) {
                this.handleYearOptions();
            }
            this.querySchoolDepartment();
            this.editDialog.visible = true;
        },

        // 切换院系
        changeDepartment() {
            const department = this.editDialog.departmentOptions.find((item) => item.department === this.editForm.className);
            this.editForm.gradeClass = '';
            this.queryClassList(department);
        },

        // 点击编辑确定
        clickEditDone() {
            if (this.trim(this.editForm.name) === '') {
                this.$util.$errorMsg('姓名不能为空');
                return;
            }
            const params = Object.assign({}, this.editForm, {
                rootUnid: this.region
            });
            this.sendUpdateVerifyInfo(params);
        },

        // 点击删除
        clickDelete(row) {
            this.$confirm('是否确定删除该信息？', '温馨提示', {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: 'warning'
            }).then(() => {
                this.sendDeleteVerifyInfo(row.stuId);
            }).catch(() => { });
        },

        // 处理年级选项
        handleYearOptions() {
            let myDate = new Date();
            let startYear = myDate.getFullYear() - 9;//起始年份
            let endYear = myDate.getFullYear() + 1;//结束年份
            for (let i = endYear; i >= startYear; i--) {
                this.editDialog.editYearOptions.push({ label: i, value: i });
            }
        },

        trim(string) {
            return string.replace(/(^\s*)|(\s*$)/g, "");
        },

    },

    beforeRouteEnter(to, from, next) {
        if (from.path === '/user/facial/photo') {
            to.meta.refresh = true;
        }
        next();
    },
    activated() {
        if (this.$route.meta.refresh) {
            this.$route.meta.refresh = false;
            this.queryUserList();
        }
    }
}
</script>
<style scoped>
.user-verification-wrapper {
    min-height: calc(130vh - 60px);
}

.tips-content {
    margin-left: 20px;
    margin-bottom: 20px;
    color: red;
    font-size: 14px;
    line-height: 28px;
}

.form-bezel {
    padding-left: 20px;
    display: flex;
    flex-direction: row;
}

.name-input {
    width: 200px;
}

.button-export {
    margin-left: auto;
    margin-right: 20px;
    height: 36px;
}

.face-image {
    margin-top: 8px;
    width: 40px;
    height: 40px;
}

.edit-form .el-form-item div {
    display: flex;
}

.edit-form .el-select {
    flex: 1;
}
</style>


// WEBPACK FOOTER //
// UserVerification.vue?694c733a